var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',[_c('h2',{staticClass:"NewsTitle"},[_vm._v(" News ")])])],1),_c('News',{attrs:{"sidebar":_vm.sidebar,"config":_vm.config}})],1),_c('div',[_c('Footer',{attrs:{"white":_vm.white,"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }